import { Link } from "react-router-dom";

const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A1C19] text-white py-10" role="contentinfo">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Links - Separate pages */}
        <nav className="flex flex-wrap items-center justify-center gap-6 mb-8 text-sm text-gray-400" aria-label="Footer navigation">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
          <Link to="/refund-policy" className="hover:text-white transition-colors">Refund Policy</Link>
          <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
        </nav>

        {/* Facebook Disclaimer */}
        <div className="mb-6 text-center">
          <p className="text-xs text-gray-400 leading-relaxed">
            This site is not a part of the Facebook website or Facebook Inc.
            <br />
            Additionally, this site is NOT endorsed by Facebook in any way.
            <br />
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>

        {/* FDA Compliance */}
        <aside className="mb-6" aria-label="FDA Compliance disclaimer">
          <p className="text-xs text-gray-500 leading-relaxed text-center">
            <strong className="text-gray-400">FDA Compliance:</strong>
            <br />
            The information on this website has not been evaluated by the Food & Drug Administration or any other medical body. We do not aim to diagnose, treat, cure or prevent any illness or disease. Information is shared for educational purposes only. You should always consult your doctor before acting on any content on this website, especially if you are pregnant, nursing, taking medication or have a medical condition.
          </p>
        </aside>
        
        {/* Copyright */}
        <div className="text-center text-gray-500 text-xs border-t border-gray-700 pt-6">
          <p>© {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
